import { FC } from 'react';

const Neutral: FC<{ filled?: boolean }> = ({ filled }) => {
    const color = filled ? '#F9DD4A' : '#BDBDBD';

    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1438_5177)">
                <path
                    d="M24.9588 50C11.2026 50 0 38.7974 0 24.9588C0 11.2026 11.2026 0 24.9588 0C38.715 0 49.9176 11.2026 49.9176 24.9588C50 38.7974 38.7974 50 24.9588 50ZM24.9588 3.29489C13.0148 3.29489 3.29489 13.0148 3.29489 24.9588C3.29489 36.9028 13.0148 46.6227 24.9588 46.6227C36.9028 46.6227 46.6227 36.9028 46.6227 24.9588C46.7051 13.0148 36.9852 3.29489 24.9588 3.29489Z"
                    fill={color}
                />
                <path
                    d="M16.3098 22.9819C17.902 22.9819 19.1928 21.6911 19.1928 20.0989C19.1928 18.5066 17.902 17.2158 16.3098 17.2158C14.7175 17.2158 13.4268 18.5066 13.4268 20.0989C13.4268 21.6911 14.7175 22.9819 16.3098 22.9819Z"
                    fill={color}
                />
                <path
                    d="M33.3608 22.9819C34.9531 22.9819 36.2438 21.6911 36.2438 20.0989C36.2438 18.5066 34.9531 17.2158 33.3608 17.2158C31.7686 17.2158 30.4778 18.5066 30.4778 20.0989C30.4778 21.6911 31.7686 22.9819 33.3608 22.9819Z"
                    fill={color}
                />
                <path
                    d="M33.9373 34.8435H16.0625C15.1564 34.8435 14.415 34.1021 14.415 33.196C14.415 32.2899 15.1564 31.5486 16.0625 31.5486H33.9373C34.8434 31.5486 35.5847 32.2899 35.5847 33.196C35.5847 34.1021 34.8434 34.8435 33.9373 34.8435Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1438_5177">
                    <rect width="50" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Neutral;
